// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1___805126fa939c1333a61","cls2":"AccountMenuButton-cls2___2fa239b708c22544a77 AccountMenuButton-cls1___805126fa939c1333a61"};